import { render, staticRenderFns } from "./AIEvaluationComponent.vue?vue&type=template&id=c1cf91ce&scoped=true&"
import script from "./AIEvaluationComponent.vue?vue&type=script&lang=js&"
export * from "./AIEvaluationComponent.vue?vue&type=script&lang=js&"
import style0 from "./AIEvaluationComponent.vue?vue&type=style&index=0&id=c1cf91ce&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1cf91ce",
  null
  
)

export default component.exports